import { render } from "./SpecialLeftMenu.vue?vue&type=template&id=60e4072c"
import script from "./SpecialLeftMenu.vue?vue&type=script&lang=js"
export * from "./SpecialLeftMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__